export default class ContextError extends Error {
  extra: Record<string, string>;

  constructor(message: string, extra: Record<string, string>) {
    super(message);
    this.extra = extra;
  }
}
